// Record roles that must always see appraisal sections as read-only, even when the
// section is empty (#1102). #1069 hides empty read-only sections from the Appraisee view;
// the roles below are exempt from that hiding and always see every section.
//
// These are RecordAccess.role values, not global roles:
//  - 'SystemRole' is assigned to HR, Staffing and TC members
//    (see PermissionService.BuildSystemRoleAccess);
//  - 'Mentor' is a record role in its own right (Mentor is not a GlobalRole,
//    so it cannot be detected via the global-role store).
const ALWAYS_VISIBLE_SECTION_ROLES: readonly string[] = ['Mentor', 'SystemRole'];

/**
 * True when the viewer's record role must always see appraisal sections, even when empty.
 * Used to exempt Mentor / TC / HR / Staffing from the #1069 empty-section hiding.
 */
export function alwaysSeesEmptySections(viewerRole: string | undefined): boolean {
  return viewerRole !== undefined && ALWAYS_VISIBLE_SECTION_ROLES.includes(viewerRole);
}
